export default {
  // 단어
  'profile': '프로필',
  'user': '사용자',
  'auto': '자동',
  'login': '로그인',
  'logout': '로그아웃',
  'ID': '아이디',
  'PW': '비밀번호',
  'PW_confirm': '비밀번호 확인',
  'PW_origin': '기존 비밀번호',
  'PW_new': '새 비밀번호',
  'PW_new_confirm': '새 비밀번호 확인',
  'SC0010': '신용카드',
  'SC0030': '계좌이체',
  'SC0060': '휴대폰 결제',
  'Superadmin': '서비스',
  'Corporate': '코퍼레이트',
  'Basic': '베이직',
  'Free': '무료체험',
  'Email': '이메일',
  'name': '이름',
  'phone': '전화번호',
  'office_phone': '사무실 전화',
  'subscription_path': '가입경로',
  'windows': '윈도우',
  'Windows': '윈도우',
  'linux': '리눅스',
  'mac': '맥',
  'android': '안드로이드',
  'agent': '에이전트',
  'download': '다운로드',
  'manual': '메뉴얼',
  'service': '서비스',
  'payment': '결제',
  'manage': '관리',
  'manager': '관리자',
  'group': '그룹',
  'information': '정보',
  'threshold': '경고기준',
  'limit': '임계값',
  'alert': '경고',
  'normal': '정상',
  'setting': '설정',
  'settings': '설정',
  'device': '에이전트',
  'type': '유형',
  'add': '추가',
  'add_n': '{v} 추가',
  'remove': '제거',
  'delete': '삭제',
  'progress': '진행',
  'time': '시간',
  'hour': '시',
  'minute': '분',
  'second': '초',
  'device-in-group': '그룹에 속한 에이전트',
  'list-of': '{v} 목록',
  'total': '전체',
  'history': '이력',
  'registration': '신청',
  'statistics': '통계',
  'update': '연장',
  'renew': '갱신',
  'connected': '연결됨',
  'disconnected': '연결끊김',
  'running': '작동중',
  'sub-manager': '하위사용자',
  'execute': '실행',
  'cancel': '취소',
  'ea': '개',
  'WON': '원',
  'months': '개월',
  'years': '년',
  'back': '뒤로',
  'expire': '만료',
  'notify': '알림',
  'help': '도움말',
  'status': '상태',
  'program': '프로그램',
  'homepage': '홈페이지',
  'web': '웹',
  'proposal': '제안서',
  'brochure': '브로셔',
  'ios': 'iOS',
  'etc': '기타',
  'on-work': '준비중',
  'list-view': '리스트',
  'card-view': '아이콘',
  'live-view': '썸네일',
  'delete-n': '{v} 삭제',
  'move-group-n': '그룹이동',
  'selected': '선택된',
  'accessable': '접근가능',
  'empty': '없음',
  'device_limit': '에이전트 최대 등록 수량 제한',
  'device_name': '에이전트 이름',
  'device_name_identical': '같은 에이전트 이름입니다.',
  'device_name_edit': '에이전트 이름 변경',
  'device_name_desc': '에이전트 이름을 <b>{alias}</b>에서 아래와 같이 변경합니다.',
  'device_config_desc': '선택된 에이전트의 구성 정보를 모두 변경합니다.',
  'name_input_path': '[변경 에이전트 이름 입력]',
  'all_different': '에이전트 이름이 <b>{alias}</b>에서<br><b>{value}</b>으로 변경됩니다. <br><br> 에이전트 구성이 <b>{oldConfigName}</b>에서<br><b>{newConfigName}</b>으로 변경됩니다.',
  'device_name_confirm': '에이전트 이름이 <b>{alias}</b>에서<br><b>{value}</b>으로 변경됩니다.',
  'device_config_confirm': '에이전트 구성이 <b>{oldConfigName}</b>에서<br><b>{newConfigName}</b>으로 변경됩니다.',
  'device_setting_edit': '에이전트 정보 변경',
  'device_apply_config': '에이전트 구성 적용',
  'device_location': '에이전트 위치 표시',
  'device_setting_desc': '<br>[변경 에이전트 구성 입력]',
  'O/S': 'O/S',
  'edit': '편집',
  'refresh': '새로고침',
  'off-editmode': '편집모드 종료',
  'emptied_memo': '-',
  'upper_group': '상위그룹',
  'all_device': '모든 에이전트',
  'submit': '확인',
  'create': '생성',
  'delete_group': '그룹삭제',
  'delete_device': '에이전트 삭제',
  'favorate': '즐겨찾기',
  'search': '검색',
  'by_user': '사용자별 {v}',
  'by_device': '에이전트별 {v}',
  'by_type': '유형별 {v}',
  'by_daily': '일별',
  'by_monthly': '월별',
  'alert_count': '경고 발생 횟수',
  'use_rate': '사용률',
  'rate': '비율',
  'use_count': '횟수',
  'select_date': '기간선택',
  'connect_count_of_remote': '원격제어 시도 횟수 추이',
  'count_of_alert': '경고 발생 횟수 추이',
  'chart': '차트',
  'date': '날짜',
  'install_date': '설치 날짜',
  'host': '호스트',
  'viewer': '뷰어',
  'at_time': '일시',
  'start_time': '시작 시간',
  'end_time': '종료 시간',
  'expire_date': '만료일',
  'event_time': '발생 시간',
  'login_time': '접속 시간',
  'delete_time': '삭제 시간',
  'payment_date': '결제 시간',
  'type_of_device': '에이전트 유형',
  'alert_message': '경고메세지',
  'browser': '브라우저',
  'file_name': '파일이름',
  'size': '크기',
  'top10': '상위10',
  'change': '변경',
  'do_change': '변경하기',
  'advenced_auth': '2단계 인증(OTP)',
  'department': '부서',
  'cowork_position': '직책',
  'timezone': '표준시간대',
  'date_format': '@:date 형식',
  'time_sec': '시간(초)',
  'auto_update': '자동갱신',
  'active': '활성화',
  'inactive': '비활성화',
  'permission': '권한',
  'target': '대상',
  'common': '공통',
  'web_manager': '웹매니저',
  'CS_manager': 'CS매니저',
  'empty_manager': '@:manager @:empty',
  'empty_phone': '@:phone @:empty',
  'empty_Email': '@:Email @:empty',
  'license': '라이센스',
  'regist_service': '@:service 신청',
  'update_service': '@:service 연장 및 갱신',
  'device_type': '제품유형',
  'device_vol': '에이전트 수',
  'remain': '남은 기간',
  'period': '기간',
  'price': '가격',
  'total_price': '총 금액',
  'payment_type': '제품유형',
  'payment_method': '결제수단',
  'remark': '비고',
  'notice': '공지사항',
  'cs_center': '고객센터',
  'cs_phone': '02-6949-0488, 070-7126-8663',
  'save': '저장',
  'find_n': '{v} 찾기',
  'signup': '회원가입',
  'trial': '무료체험하기',
  'use_for': '가입 구분',
  'personal': '개인',
  'enterprise': '기업',
  'company': '회사',
  'package_name': '패키지 이름',
  'package_id': '패키지 ID',
  'app_name': '앱 이름',
  'app_version': '앱 버전',
  'upload': '업로드',
  'url': 'URL',
  'file': '파일',
  'action': '액션',
  'continue': '계속',
  'temperature': '온도',
  'speed': '속도',
  'running_time': '러닝 타임',
  'system_time': '시스템 시간',
  'version': '버전',
  'access_log': '접근/제어 이력',
  'list_of_process': '프로세스 목록',
  'list_of_hardware': '하드웨어 목록',
  'list_of_software': '소프트웨어 목록',
  'enter_n': '{v} 입력',
  'reset_n': '{v} 재설정',
  'authorization': '본인 인증',
  'send_n': '{v} 보내기',
  'resend_n': '{v} 재전송',
  'close': '닫기',
  'secure': '보안',
  'available_count': '사용가능기기',
  'submanager-right': '부서장 권한',
  'access-registration-history': '에이전트 원격제어 접근신청 내역',
  'access-num': '일련번호',
  'device-name': '에이전트명',
  'device-ip': '에이전트 아이피',
  'application-date': '접수시간',
  'application-period': '신청기간',
  'approver': '승인자',
  'applicant': '신청자',
  'approval-status': '승인여부',
  'approval': '승인',
  'approval-ing': '진행중',
  'function-settings': '정책관리',
  'function-settings01': '로그인 실패 계정 잠금 횟수(회)',
  'function-settings02': '원격접속 유휴시간(분)',
  'function-settings03': '파일전송',
  'blocking-settings': '접속 IP 관리',
  'blocking-settings01': '차단/허용 정책',
  'approval-submit-user': '재신청',
  'blocking-super-settings': '정책사용',
  'reset-pw': '초기화',
  'reject-submit': '반려',
  'reject': '거부',
  'security-access': '동의',
  'manager-id': '관리자',
  'sub-manager-id': '중간관리자',
  'reject-access': '승인취소',
  'request-agent': '에이전트',
  'request-date': '신청기간',
  'request-reason': '사유',
  'approval-reason': '부서장의견',
  'security-access-title': '보안서약서 동의',
  'excel-form': 'Excel 양식 다운로드',
  'approval-apply': '승인프로세스 적용',
  'user-in-group': '그룹 접근 권한 사용자',
  'deleted-device-edit': '수정',
  'request-history': '접근신청 내역',
  'approval-process': '접근신청 승인',
  'approval-process-history': '접근신청 승인내역',
  'major-os-version': '메이저OS 버전',
  'minor-os-version': '마이너OS 버전',
  'session-time': '원격접속 유지시간(분)',
  'account_security': '계정보안',
  'password_level': '비밀번호 난이도 설정',
  'password_level0': '제한 없음 (4자리 ~ 12자리)',
  'password_level1': '영문 + 숫자 (6자리 ~ 12자리) 이내로 입력하세요.',
  'password_level2': '영문 + 숫자 + 특수문자 (8자리 ~ 12자리) 이내로 입력하세요.',
  'password_level3': '대문자 영문 + 소문자 영문 + 숫자 + 특수문자 (8자리 ~ 12자리) 이내로 입력하세요.',
  'self_unlock': '잠금 계정 자가 해제 허용',
  'vaccine': '프로세스/서비스명 감지',
  'capture': '화면 캡쳐 및 녹화',
  'display-power-save': '화면 절전 방지',
  'system-power-save': '시스템 절전 방지',
  'security-agreement': '보안서약서 사용',
  'remote-policy': '원격 기능 정책',
  'user-connection-policy': '사용자 접속 환경 정책',
  'os-version': 'Windows OS 버전 허용',
  'blocking-settings-ip-list': '접속 IP 목록',
  'single-ip': 'IP 단일주소',
  'reason': '사유',
  'range-ip-start': '시작 주소',
  'range-ip-end': '끝 주소',
  'subnet-ip': '서브넷팅 주소',
  'time-added': '적용시간',
  'ip-address': 'IP 주소',
  'password-expired': '비밀번호 최대사용기간(일)',
  'excel-users': '사용자 일괄 등록',
  'enrollment': '등록',
  'excel-groups': '그룹 일괄 등록',
  'account-manage': '사용자',
  'all-devices': '에이전트',
  'tutorial': '튜토리얼',
  'device-drop-all': '모든 PC',
  'service-payment-history': '서비스 결제내역',
  'tutorial-device': '처음 사용하시나요? (원격지 PC 추가하는 방법 보기)',
  'tutorial-group': '그룹관리 안내가 필요하신가요? (그룹관리 기능 보기)',
  'tutorial-manager': '사용자 계정이 뭔가요? (계정관리 기능 보기)',
  'tutorial-statistics': '통계/이력에서 제공하는 기능은 무엇인가요? (통계/이력 기능 보기)',
  'tutorial-top10': '그룹관리 안내가 필요하신가요? (그룹관리 기능 보기)',
  'tutorial-download': '에이전트 다운로드 및 설치 가이드',
  'tutorial-license': '전자결제가 안되시나요?',
  'first-add-device': '원격지 PC 추가',
  'system-checker': '시스템 환경진단 툴',
  'execute-or-not': '실행여부',

  
  // 메세지
  'no-selects': '선택된 항목이 없습니다.',
  'no-content': '해당되는 항목이 없습니다',
  'on_working': '준비중 입니다.',
  'has_new_message': '새로운 알림이 있습니다',
  'not_save_warning': '저장하지 않는 내용은 반영되지 않습니다. 진행하시겠습니까?',
  'not_online_warning': '에이전트가 온라인 상태가 아닙니다.',
  'no_input_data': '입력한 내용이 없습니다.',
  'add_child_group': '"{name}"의 하위 그룹을 추가합니다.<br>그룹 이름을 입력해주세요.',
  'add_root_group': '"최상위"에 그룹을 추가합니다.<br>그룹 이름을 입력해주세요.',
  'duplication_group_name': '같은 이름의 그룹이 같은 위치에 있습니다.',
  'created_group': '그룹을 생성했습니다.',
  'please_select_group': '그룹을 선택해 주세요.',
  'identical_group': '동일한 에이전트 그룹으로 그룹 이동을 시도하셨습니다. 다른 에이전트 그룹을 선택하여 주십시오.',
  'confirm_delete_group': '그룹 삭제 시, 해당 그룹의 기기는 기본그룹으로 이동합니다.<br>삭제하시겠습니까?',
  'deleted_group': '그룹이 삭제되었습니다.',
  'all_device_has_no_child': '모든에이전트에 하위그룹을 포함할 수 없습니다.',
  'confirm_delete_device': `
    등록된 에이전트를 삭제합니다.<br>
    삭제된 에이전트를 다시 연결하려면 원격지에서 로그인이 필요합니다.<br>
    <br>
    <h6 class="delete-target">{name}</h6>
  `,
  'access-ticket': '제어권 신청',
  'ticket-request': '제어권 신청 관리',
  'at.requested': '승인요청중',
  'at.re-requested': '재승인요청중',
  'at.approved': '승인완료',
  'at.on-work': '작업중',
  'at.reject': '반려됨',
  'at.completed': '종료',
  'at.Unknown': '알수없는상태',
  'has_request_ticket': '{count}개의 제어권 신청이 있습니다',
  'deleted_device': '에이전트가 삭제되었습니다.',
  'moved_device': '[{device}]이(가) [{group}]으로 이동하였습니다.',
  'moved_device_by': '[{device}]이(가) [{group}] 옆으로 이동하였습니다.',
  'moved_device_fail': '{name}은(는) 옮길 수 없습니다.',
  'deleted_device_count': '[{count}/{total}] 에이전트가 삭제되었습니다.',
  'no_order_warning': '그룹 순서 이동은 지원하지 않습니다. 오름차순으로 정렬됩니다',
  'delete_user_confirm': '해당 사용자를 삭제 하시겠습니까?',
  'delete_group_confirm': '해당 그룹을 삭제 하시겠습니까?',
  'delete_checked_user_confirm': '선택한 사용자를 정말 삭제하시겠습니까?',
  'user_active_changed': '"{name}"이(가) "{status}"로 변경되었습니다.',
  'deleted_user': '사용자가 삭제되었습니다.',
  'created_user': '사용자가 등록되었습니다.',
  'updated_memo': '메모가 수정되었습니다.',
  'update_agent_requested': '업데이트가 요청되었습니다.',
  'update_agent_desc': '원격지 기기의 에이전트 프로그램을 업데이트 합니다. <br>현재 버전: {current_ver} > 최신 버전: {latest_ver}',
  'update_agent_descs': '원격지 기기들의 에이전트 프로그램을 업데이트 합니다.',
  'delete_threshold': '해당 경고기준을 삭제하시겠습니까?',
  'no_perm_group': '이 그룹에 대한 권한이 없습니다.',
  'add_permission_of_group': `
    이 그룹의 권한을 부여하기 위해 아래의 상위그룹에 대한 권한이 필요합니다.
    <br><br>
    [{groups}]
    <br><br>
    허용하시겠습니까?
  `,
  'delete_permission_of_group': `
    이 그룹의 권한을 제거하기 위해 아래의 하위그룹에 대한 권한제거가 필요합니다.
    <br><br>
    [{groups}]
    <br><br>
    허용하시겠습니까?
  `,
  'please_select': '선택해 주세요.',
  'please_input': '입력해 주세요.',
  'please_select_device_type': '에이전트유형을 @:please_select',
  'please_select_alert_type': '경고 유형을 @:please_select',
  'please_input_alert_time': '진행 시간을 @:please_input',
  'please_input_alert_value': '임계값을 @:please_input',
  'please_input_memo': '메모를 @:please_input',
  'permissions': {
    'deviceMonitor': '에이전트 모니터링',
    'CSRemoteControl': '원격 제어',
    'CSFileManager': '파일 전송',
    'modifyInformation': '정보 수정',
    'useFunction': 'PC재시작/종료/삭제',
    'viewReport': '통계/이력 보기',
    'CSRemoteView': '원격 보기',
    'CSDeviceManagement': '에이전트 이름수정/삭제',
    'CSUpdate': '에이전트 업데이트',
    'CSThumbnailView': '썸네일 뷰',
    'CSRestart': 'PC재시작',
  },
  'getin_with': {
    'internet_search': '인터넷 검색',
    'recommendation': '지인 추천',
    'advertising': '광고/신문/매체',
    'sns': 'SNS/블로그',
    'pcany': '피씨애니 유료 고객',
    'etc': '기타',
  },
  'added_device_in_group': '에이전트가 그룹에서 추가되었습니다.',
  'removed_device_in_group': '에이전트가 그룹에서 제거되었습니다.',
  'changed_group_info': '그룹정보가 변경되었습니다.',
  'remote': {
    'remote': {
      'title': '원격제어',
      'title2': '원격제어',
      'desc': '에이전트 연결을 시작합니다.',
      'desc_additional': `<br>(원격제어가 실패하면 다운로드 버튼을 눌러 프로그램을 다운로드 후 실행해주세요.)`,
      'desc_mac': '원격제어를 시작하시겠습니까?<br>(첫 실행 시 프로그램을 먼저 설치해주세요)',
      'activex': '잠시 후 런처가 실행됩니다.',
      'activex_error': 'ActiveX 실행에 실패했습니다.',
      'download': '런처가 다운로드되면 실행해주세요.',
      'application': '잠시 후 앱 런처가 실행됩니다.',
      'error': '런처 실행에 실패하였습니다.',
      'urlscheme': '잠시 후 프로그램이 실행됩니다',
    },
    'transfer': {
      'title': '파일전송',
      'desc': '파일전송를 시작 하시겠습니까?',
      'activex': '잠시 후 런처가 실행됩니다.',
      'activex_error': 'ActiveX 실행에 실패했습니다.',
      'download': '런처가 다운로드되면 실행해 주세요.',
    },
    'reboot': {
      'title': '장치 재시작',
      'desc': '※ 해당 에이전트 자동실행 / 로그인 기능이 꺼져있는 경우 원격 연결이 불가합니다.  에이전트를 재시작 하시겠습니까?',
      'requested': '재부팅이 요청되었습니다.',
    },
    'restart': {
      'title': '에이전트 재시작',
      'desc': '에이전트 프로그램을 재시작 합니다.',
      'descs': '온라인 중인 에이전트 프로그램들을 재시작 합니다.',
      'requested': '에이전트 재시작이 요청되었습니다.',
    },
    'shutdown': {
      'title': '장치 종료',
      'desc': '※ 시스템이 종료되는 경우 오프라인 상태로 전환되어 원격 연결이 불가합니다.  에이전트의 시스템을 종료 하시겠습니까?',
      'requested': '시스템 종료가 요청되었습니다.',
    },
    'preview': {
      'title': '스크린샷',
    },
    'detail': {
      'title': '상세정보',
    },
    'delete': {
      'title': '에이전트 삭제',
    },
    'wol': {
      'title': 'WOL 전원켜기',
      'desc': '"{device}" 장비를 하기 장비를 통하여 WOL로 켭니다. 장비를 선택하여 주십시오.',
      'success': 'WOL 신호를 전송했습니다.',
    },
    'approve': {
      'title': '제어권없음',
      'desc': '접근신청서 작성',
    },
    'web': {
      'title': '원격제어(웹뷰어)',
    },
    'normal': {
      'title': '원격제어',
    },
    
  },
  'columns': {
    'alive': '상태',
    'actions': '기능',
    'alias': '에이전트 이름',
    'memo': '메모',
    'last_connected_time': '로그인일시',
    'group': '그룹',
    'connect': '접속',
  },
  'id_exist': '이미 존재하는 아이디입니다.',
  'reserved': {
    'ROOT': '기본그룹',
  },
  'audit-message': {
    '1': '원격제어 기능을 수행하였습니다.',
    '2': '파일관리자 기능을 수행하였습니다.',
    '3': '시스템을 재시작하였습니다.',
    '4': '시스템을 종료하였습니다.',
    '5': '에이전트를 최신버전으로 업데이트 하였습니다.',
    '11': '에이전트의 이름을 \'{old_value}\'에서 \'{new_value}\'로 변경하였습니다.',
    '12': '에이전트에 메모를 \'{old_value}\'에서 \'{new_value}\'로 변경하였습니다.',
    '21': '\'{old_value}\'에서 \'{new_value}\'로 그룹을 이동하였습니다.',
    '30': '{old_value} 에서 {new_value} 로 변경하였습니다.',
    '31': '예약(켜기) : {new_value}을 추가하였습니다.',
    '32': '예약(끄기) : {new_value}을 추가하였습니다.',
    '33': '예약(켜기) : {new_value}번째 설정을 제거 하였습니다.',
    '34': '예약(끄기) : {new_value}번째 설정을 제거 하였습니다.',
    '35': '리모컨 : {new_value} 실행하였습니다.',
  },
  'response_error_server_error': '데이터를 불러오는 중 일시적인 오류가 발생하였습니다. 잠시 후 다시 시도해 주세요.',
  'response_error_connect_failed': '서버에 연결할 수 없습니다. 잠시 후 다시 시도해 주세요.',
  'not_supported_os': '지원하지 않는 운영체제입니다.',
  'online_agents_restart': '온라인 중인 에이전트들의 재시작이 요청되었습니다.',
  'all_agents_restart': '모든 에이전트들의 재시작이 요청되었습니다.',
  'alert_license': '라이센스 만료 알림',
  'need_license': '{v} 라이센스가 필요합니다.',
  'invalid_id_and_pw': '아이디와 비밀번호를 확인해 주세요.',
  'login_failed_cause_step1': '아이디와 비밀번호를 확인해 주세요.',
  'login_failed_cause_step2': '이메일 인증이 이루어지지 않았습니다.<br>인증메일을 못받으신 분들은 인증메일 재전송 버튼을 눌러주시기 바랍니다.',
  'login_failed_cause_flag_active': '계정이 비활성화 됐습니다.<br>담당자에게 문의해 주세요.',
  'login_failed_cause_superadmin': '외부접속은 제한되어 있습니다.',
  'invalid_id': '올바른 아이디를 입력해 주세요',
  'invalid_otp': 'OTP 인증암호가 잘못되었습니다. 다시 입력해주세요.',
  'name_requirement': '이름을 입력해 주세요.',
  'phone_requirement': '전화번호를 입력해 주세요',
  'emile_requirement': '이메일 형식으로 입력해 주세요',
  'subspath_requirement': '가입경로를 입력해 주세요',
  'company_name_requirement': '회사이름을 입력해 주세요',
  'digit_n_requirement': '디지털 숫자 {v}개를 입력하세요',
  'dont_show_again': '더 이상 보지않기', // 'Don\'t show again'
  'signup_done': '회원가입 완료',
  'free_trial_message': '<strong>기기 5대 15일간 무료</strong>지금부터 원격제어 PCCL을<br>마음껏 이용해 보세요.',
  'enter_new_password': '새 비밀번호 입력',
  'search_location': '지역이름을 검색하세요',
  'accessable_user_desc': '해당 그룹의 에이전트 접근 권한이 있는 하위 사용자 목록입니다.',
  'password_requirement': '비밀번호는 영문 대,소문자, 특수문자, 숫자를 혼합하여 8~12자리 이내로 입력하세요.',
  'password_confirm': '비밀번호가 일치하지 않습니다.',
  'password_modify_mail_sent': '비밀번호 변경 이메일이 발송되었습니다.',
  'password_modified': '비밀번호가 변경되었습니다.',
  'password_modified_failed': '비밀번호 변경이 실패하였습니다.',
  'otp_reset_complete': 'OTP가 초기화 되었습니다.',
  'otp_reset_failed': 'OTP가 초기화에 실패하였습니다.',
  'password_reset_desc': '비밀번호를 재설정하시기 바랍니다.',
  'forgot_desc': '아이디 찾기 또는 비밀번호 찾기를 통해 해결이 불가능하시다면<br>' +
      'Support@linkmemine.com 으로 메일 문의' +
      '<br>또는 상단의 톡톡상담을 클릭해주시기 바랍니다.',
  'expired_desc': '계속 이용하시려면 기존 라이센스를 갱신 하시거나<br>삭제 할 디바이스를 선택 해 주시기 바랍니다.',
  'email-invalid': '정확한 이메일을 입력해 주세요',
  'email-auth-wait': '이메일 인증을 하고 있습니다.<br>잠시만 기다려 주세요',
  'email-auth-already': '이메일 인증이 이미 완료되었습니다',
  'email-auth-fail': '이메일 인증에 실패하였습니다',
  'email-auth-success': '이메일 인증을 성공하였습니다.<br>로그인하여 주시기 바랍니다.',
  'login_description': '고객님이 가지고 있는 모든 PC나 스마트 기기, IoT 장비에 접속할 수 있습니다',
  'join_description': 'PCCL 회원가입을 환영합니다.<br>회원 가입 이후 등록하신 이메일로 발송된 메일 인증 후 사용해주세요.',
  'go_login': '로그인하러가기',
  'your_email_is': '고객님의 아이디는<br>{email}입니다.',
  'not_matched_user': '일치하는 사용자가 없습니다.',
  'is_pcany_customer': '현재 피씨애니의 유료 고객이십니까?',
  'add_manager_desc': `
    <div>1. 하위 사용자 계정은 별도의 이메일 인증 없이 생성 후 바로 사용이 가능합니다..</div>
    <div>2. 하위 사용자 계정으로 로그인한 에이전트는 관리자 계정에 귀속되여 보여집니다.</div>
    <div>3. 각 하위 사용자에 대한 권한 설정 및 접근 가능 에이전트 그룹 설정이 가능합니다.</div>
  `,
  'free_trial_comment': '무료체험 중 입니다. 서비스를 연장해 주세요.',
  'secure_login_desc': '만약 보안코드 6자리를 확인할 수 없다면<br>고객센터로 연락주시기 바랍니다.',
  // 'payment_tax_desc1': '*부가세 포함이며, 1년 약정시 2개월분 금액이 할인됩니다.<br>** 제품 유형(라이센스) 변경 및 1년이상 장기 약정 희망시 고객 센터로 문의 바랍니다.<br>전화번호 : 070-7126-8663, 02-6949-0488<br>전자결제문의 : 1544-7772',
  'payment_tax_desc1': '메일문의 : support@linkmemine.com',
  // 'payment_tax_desc2': '세금계산서 필요시 입금 안내',
  'payment_tax_desc2': '전자결제문의 : 1544-7772(토스페이먼츠)',
  // 'payment_tax_desc3': '전자결제를 진행하신 고객은 전자세금계산서 발급이 불가합니다.<br>세금계산서 발행을 원하실 경우 아래 계좌로 직접 입금하신 후 연락 주시기 바랍니다.<br>우리은행 (주) PCCL 1005-402-963384',
  'payment_tax_desc3': '세금계산서 발급 요청 : https://linkmemine.co.kr',
  'not_email_auth': '인증 메일을 발송하였습니다.<br>메일을 확인해주세요.',
  'email_send_fail': '이메일 발송이 실패했습니다. 이메일 주소를 확인해 주세요',
  'mobile_store': `
    모바일 원격제어는<br>
    어플리케이션을 이용해주세요.<br><br>
    <a href="{url}" target="_blank">스토어로 바로가기</a>
  `,
  'OTP_desc': '웹매니저 로그인 시 Google OTP로 2단계 인증을 진행합니다',
  'agreement': {
    'desc': '이용약관과 개인정보 수집/이용에 대한 동의를 해주세요.',
    'agree_all': '모두 동의 합니다',
    'agree_use': '이용약관 동의',
    'agree_use_context': `
      [PCCL 약관]
      
      
      제1조 (목적)
      
      본 약관은 pCloud(이하 "회사"라 한다)가 운영하는 웹사이트(이하 “사이트”라 한다)에서 제공하는 인터넷 관련 서비스(이하 "PCCL"이라 한다)를 이용함에 있어 회사와 이용자간 이용조건 및 절차와 권리•의무 및 책임 사항을 규정함을 목적으로 합니다.
      
      
      제2조 (정의)
      
      1) "회원"이라 함은 회사가 운영하는 사이트에 접속하여 이 약관에 동의하고 아이디 및 비밀번호를 발급받아 회원등록을 하며 회사의 정보를 제공받고 서비스를 지속적으로 이용할 수 있는 자를 말하며 회사가 정한 회원의 구분에 따라 유료회원과 일반회원으로 구분됩니다.
      
      2) "서비스"란 회사의 사이트를 통하여 데스크톱, 모바일단말기기 등 유무선기기와 인터넷을 통해 접속하는 회원 또는 이용자에게 원격지원, 원격상담, 원격제어 등 원격 관련 비대면 서비스를 이용할 수 있도록 무료 또는 유료로 제공하는 행위 또는 그 행위의 대상인 유•무형의 제품 자체를 의미합니다.
      
      3) “이용계약"이라 함은 회사 서비스와 관련하여 회사와 회원간 체결하는 계약을 말합니다.
      
      4) “유료회원"이라 함은 회사에 유료서비스 가입신청서를 제출하고 이를 회사가 승인하여 이용요금의 납부의무를 가진 법인 또는 개인을 의미합니다.
      
      5) "일반회원"이라 함은 회사가 운영하는 사이트의 이용약관에 동의하고 ‘이용신청 및 승인’ 절차에 의하여 회원으로 등록된 자를 의미합니다.
      
      6) "아이디"라 함은 회원식별과 서비스 이용을 위해 회원이 선정하고 회사가 승인하는 식별주체로 문자와 숫자의 조합 또는 회원의 이메일 주소를 의미합니다.
      
      7) "비밀번호(Password)"라 함은 회원이 부여받은 아이디에 대해 회원이 네트워크상에서 본인의 비밀보호를 위해 설정한 문자와 숫자 및 특수문자의 조합을 의미합니다.
      
      8) "계약해지"라 함은 회사 또는 회원(회원신청상태 포함)이 서비스 개통 후 서비스에 대한 이용계약을 해지하는 것을 말합니다.
      
      9) “계약취소"라 함은 회사 또는 서비스신청자가 서비스 개통 전 이용계약을 해지하는 것을 말합니다.
      
      10) "개통일"이라 함은 신청자가 서비스를 신청한 후 회사가 서비스를 이용할 수 있도록 승인 절차와 개통처리를 완료한 일자를 의미합니다.
      
      11) "해지일/취소일"은 회사 또는 신청자가 이미 신청한 서비스의 이용(및 이용 전) 종료를 요청하여 회사가 검토하여 종료키로 한 날짜를 의미합니다.
      
      12) "불법통신"은 국가기밀 침해, 청소년 보호법상 청소년 유해 매체물, 음란한 내용, 불법복제 등 지적재산권 침해, 비방 및 허위사실에 의한 타인 명예훼손 등이 포함된 통신구현형태를 의미합니다.
      
      13) "게시물"은 서비스를 이용할 때 회원이 여러 유형의 단말기기(데스크톱, 모바일기기, TV등 유무선기기 포함)를 통해 회사 사이트에 게시한 부호, 문자, 음성, 음향, 화상, 동영상 등의 정보를 전달하는 문장, 이미지, 동영상 등의 각종 파일과 그 링크를 말합니다.
      
      14) "결제대행업자"는 회원에게 결제수단을 선택하게 하려고 회사가 지정한 전자지불 서비스를 대행하는 업체를 말합니다.
      
      
      제3조 (약관의 효력과 개정)
      
      1) 회사는 서비스의 효율적인 제공을 위하여 본 약관을 수정 또는 변경할 수 있으며 변경된 약관은 회사의 사이트 홈페이지(https://www.anysupport.net)에 공지합니다.
      
      2) 약관에 동의하고 회원가입을 한 회원의 경우 약관 동의 시점부터 동의한 약관의 적용을 받되 약관의 변경이 있을 경우 변경의 효력이 발생한 시점부터 변경된 약관의 적용을 받습니다. 변경된 약관은 공시 또는 고지한 적용일로부터 효력을 발생합니다.
      
      3) 회사는 필요하다고 인정되는 경우 약관을 변경할 수 있습니다. 약관이 변경되는 경우 변경된 약관의 내용과 적용일을 정해 그 적용일로부터 7일전까지 홈페이지에 공지하거나 회원의 이메일로 전송하는 방법으로 고지합니다. 단, 변경내용이 회원에게 불리하거나 중대사항 변경에 해당할 경우 30일 전에 고지합니다.
      
      4) 회원이 본 약관의 변경에 동의하지 않을 경우 이용을 중단하고 이용계약 해지 및 회원탈퇴할 수 있습니다. 약관시행일까지 회원탈퇴를 하지 않은 경우 개정약관에 동의한 것으로 간주합니다.
      
      5) 본 약관에 명시되지 않는 사항에 대해 ‘전자상거래 등에서의 소비자보호에 관한 법률’, ‘정보통신망이용촉진 및 정보보호 등에 관한 법률’, 등 관계법령 및 회사 개별 서비스별 별도의 이용약관 및 규정이 있는 경우에 이를 따르도록 합니다.
      
      
      제4조 (서비스의 제공 및 계약의 성립)
      
       1) 회사가 제공하는 서비스 이용을 원하는 신청자가 본 약관에 동의를 한 후 회사가 제시하는 양식과 절차에 따라 신청한 내용에 대해 회사가 아이디 개통 후 사용허가를 함으로 회사와 신청자간 이용계약이 성립됩니다.
      
       2) 신청자가 이용약관을 동의한다는 의사표시는 서비스를 이용하고자 하는 대상이 이용신청시 약관에 대한 동의 체크를 하여 완료됩니다. 오프라인 이용신청의 경우 신청자의 가입신청서 및 관련서류 제출을 수반한 회사의 이용신청 기준에 의거 완료됩니다.
      
       3) 계약이 성립된 후 회사는 회원에게 본 약관이 정하는 기준에 의거 회원아이디를 이메일과 같은 온라인 매체를 통해 전달하며 서비스 이용기간 동안 회원아이디의 변경은 원칙적으로 불가합니다.
      
       4) 온라인 및 오프라인 양식에 제출하는 모든 정보는 허구가 없는 실데이터여야 하고 만약 실명 또는 실 정보를 입력하지 않은 회원의 경우 법적인 보호를 받을 수 없습니다.
      
       5) 이용신청을 위한 정보는 홈페이지 회원가입 화면에서 아래와 같은 내용을 정확히 포함하여야 합니다.
      
          - 아이디(ID), 비밀번호(Password), 회원명(Name), 회사이름(Company), 국적(Nationality), 연락처(Mobile phone, Telephone, Email)
      
       6) 지속적인 과금이 필요한 유료서비스를 이용하는 경우는 상기 이용신청정보 외 아래 서류를 직접 방문하거나 우편, 팩스 등 회사가 인정하는 형태의 문서 및 전자문서를 통해 제출해야 합니다. 단, 제휴나 연계 등으로 회사가 직접 결제를 하지 않는 경우는 회사 내부 검토 후 예외로 할 수 있습니다.
      
          - 서비스가입신청서(회사소정양식),
      
      요금납부회사 사업자등록증(개인은 주민등록증 사본), 기타 신원확인 등을 위하여 회사가 요청하는 부대서류 및 기타 필요 서류
      
       7) 이용을 신청한 회원이 미성년자 또는 한정치산자의 경우 신청자와 요금납부자를 부모 또는 법정대리인으로 하여야 합니다.
      
       8) 회사는 회원이 신청한 내용을 검토하여 약관, 업무진행 및 기술상 문제가 없을 경우 서비스 이용을 허락함을 원칙으로 하나 아래와 같은 경우 허가하지 않거나 거절할 수 있습니다.
      
          - 이용신청서의 내용을 허위 기재 및 허위서류를 첨부한 경우
      
          - 실명을 사용하지 않거나 타인의 명의로 신청할 경우
      
          - 서비스 미제공 대상국가에서 비정상적 또는 우회 방식으로 서비스를 이용한 경우
      
          - 공공질서 및 미풍양속을 해칠 우려가 있는 경우
      
          - 신용불량자(신용정보의 이용 및 보호에 관한 법률 기준)인 경우
      
          - 회사 미납요금이 존재하는 경우
      
          - 회사 설비를 통해 처리하기 어렵거나 기술적으로 서비스 제공이 어려운 경우
      
          - 이용신청대상의 귀책사유로 인해 이용허가가 어려운 경우
      
          - 기타 회사가 필요하다고 인정할 경우
      
       9) 유료납부서비스의 경우 회원은 계약성립 후 회사의 절차에 따라 이용료를 선납해야 하며 이후부터 서비스가 개시됨을 원칙으로 합니다.
      
      10) 회원은 아래와 같은 해당하는 사유가 발생한 경우에는 사유발생 즉시 이메일 또는 회사가 제공하는 안내에 따라 변경사항을 회사에 알려야 합니다.
      
          - 회원 및 요금납입자의 회사, 성명, 주소 또는 연락처 변경
      
          - 서비스의 내용 (계약기간, 서비스 종류 등) 변경
      
          - 요금 납부 방식 변경
      
      11) 회원이 계약해지를 원하는 경우에는 본인이 직접 온라인, 전화, 팩스, 이메일 등의 방법으로 해지 7일전까지 회사에 해지신청서를 제출하여야 합니다.
      
      12) 회원의 해지요청에 따라 서비스가 해지된 후 발생된 게시물 또는 회원정보 소멸 등에 대한 책임은 회원에게 있으며, 회사에게 이로 인한 손해배상을 청구할 수 없습니다.
      
      13) 회사는 다음 각호의 경우에는 계약을 해지할 수 있습니다.
      
          - 회원이 제7조 서비스 이용제한에 관한 각호의 사유에 해당하는 경우
      
          - 회원이 제8조 회원의 의무에 관한 조항을 위반한 경우
      
      14) 회사는 회사 업무상 또는 기술상 장애로 인하여 서비스를 개시하지 못하거나 개통하지 못하는 경우 회원에게 대표 홈페이지 또는 개별 서비스 관련 홈페이지에 공시하거나 이메일 등으로 이를 통지합니다.=
      
      15) 회사는 회사 필요에 의해서 사전고지 없이 서비스 내용을 추가 또는 변경할 수 있으며, 필요한 경우 서비스 추가 또는 변경된 사항을 서비스 제공 사이트에 게시하거나 이메일 등으로 별도 공지할 수 있습니다.
      
      16) 회사는 무료 제공 서비스 일부 또는 전부를 회사 정책 및 운영 상 필요할 경우 수정, 중단, 변경할 수 있으며, 이에 대해 관계법령에 특별한 규정이 없는 한 회원에게 별도 보상하지 않습니다.
      
      17) 회원은 회사의 “개인정보보호정책”에 동의하며, 회사는 회원 개인정보를 본 이용계약의 이행과 본 이용계약상의 서비스제공을 위한 목적으로 이용합니다.
      
      18) 회사는 회원 실명여부를 확인하기 위해 회원 사전동의 없이 회사가 별도로 계약한 신용정보회사에 회사에 기재된 정보를 제공하여 실명여부를 확인할 수 있습니다.
      
      19) 회사는 업무와 관련하여 회원 전체 또는 일부 개인정보 관련 통계를 작성하여 이를 사용할 수 있고, 서비스를 통해 회원의 컴퓨터에 쿠키를 전송할 수 있습니다. 이 경우 회원은 쿠키의 수신을 거부하거나 쿠키의 수신에 대하여 경고하도록 사용하는 컴퓨터 브라우저의 설정을 변경할 수 있습니다. 단, 이렇게 수집된 개인정보는 전체적인 통계자료로만 활용합니다.
      
      20) 회사는 서비스 웹사이트를 방문한 사용자 웹로그를 수집하고 통계를 작성하여 이를 사용할 수 있으며, 웹로그에 대한 수집, 통계를 위하여 웹사이트에 스크립트를 삽입하고 있습니다.
      
      21) 웹로그에는 사용자 개인정보(이름, 나이, 주민등록번호 등)는 비포함이며, 사용자 사용 패턴 분석을 위한 방문기록과 이동경로 등의 비개인성 정보만이 포함됩니다.
      
      22) 회사는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 이메일 등의 방법으로 회원에게 제공할 수 있으며 회원은 언제든지 이메일 등을 통하여 수신거부를 할 수 있습니다.
      
      23) 회사는 서비스 운영과 관련하여 서비스 화면, 홈페이지, 이메일 등에 광고를 게재할 수 있습니다. 광고가 게재된 이메일 등을 수신한 회원은 회사에 수신거부를 할 수 있습니다.
      
      24) 회사가 제공하는 서비스는 배너, 링크(Link) 등 다양한 형태의 광고가 포함되어 있을 수 있으며, 이는 제3자가 제공하는 페이지와 연결될 수 있습니다. 단, 제3자가 제공하는 페이지로 연결될 경우 해당 페이지는 회사 서비스 영역이 아니므로 회사가 신뢰성, 안정성 등을 보장하지 않으며 그로 인한 회원 손해에 대하여 회사는 일체의 책임을 지지 않습니다.
      
      25) 각종 이벤트를 통한 당첨경품 수령 시 수령하는 회원이 회원가입 시 입력한 회원정보에서 허위 기재한 사항이 있을 경우 모든 권리(당첨자 대상 및 상품수령 포함)가 박탈될 수 있습니다.
      
      26) 별도 기준에 의거 부여하는 각종 상품은 미리 정해진 일자에 본인확인 후 제공하거나 또는 온라인 송금되며 상품에 따라 각종 세금 및 배송료가 부과될 수 있습니다.
      
      27) 회사는 새로운 서비스를 유료 제공 전 회원들을 대상으로 일정 기간 테스트 목적의 서비스를 제공할 수 있습니다.
      
      28) 테스트 목적 서비스는 서비스 안정성 등을 위해 사전 공지 없이 수시로 프로그램이 업데이트될 수 있습니다.
      
      29) 테스트 서비스의 경우 테스트 서비스 종료와 함께 회원정보, 게시물은 삭제되며, 서비스 이용권한도 정지되는 것을 원칙으로 합니다.
      
      30) 회사는 전자상거래법, 정보통신망법 등 관계 법령에 의하여 보존할 대상의 경우 거래기록을 최대 5년간 보존합니다.
      
      31) 회사 내의 데이터베이스에 보존된 자료와 청구기관 측의 데이터베이스에 보존된 자료의 기재내용이 달라 회사가 회원에게 자료 기재 내용의 확인을 요구할 경우 회원은 이에 응해야 합니다.
      
      
      제5조 (서비스의 중단 및 게시물·내용물 삭제)
      
       1) 회사는 아래에 해당 시 서비스 전부 또는 일부를 제한하거나 중지할 수 있습니다.
      
          -천재지변, 국가비상사태 등 불가항력적인 사유가 있는 경우
      
          -전기통신사업법에 규정된 기간통신사업자가 전기통신서비스를 중지하였을 경우
      
          -서비스용 설비 보수, 정기점검 등 공사로 인한 부득이한 경우
      
          -정전, 제반 설비 장애나 이용량 폭주 등으로 정상적 서비스 이용에 지장이 있는 경우
      
          -기타 회사 업무상 또는 기술상의 이유로 서비스 중지가 필요하다고 판단되는 경우
      
       2) 서비스 중단이 있는 경우에는 회사가 제8조에 기술된 회원에 대한 통지에 정한 방법으로 회원에게 사전 통지합니다.
      
       3) 회사가 통제할 수 없는 사유로 인한 서비스 중단으로 인해 사전 통지가 불가능한 경우에는 사후 이를 홈페이지 또는 개별 서비스 관련 홈페이지에 공지할 수 있습니다.
      
       4) 회사는 본 조 제1항의 사유로 서비스 제공이 일시적으로 중단됨으로 인하여 회원의 손해에 대하여 책임지지 않습니다.
      
       5) 회사는 회원이 게시하거나 전달하는 서비스 내의 모든 내용물(회원간 전달도 해당)이 아래의 경우에 해당한다고 판단되는 경우 사전통지 없이 삭제하거나 등록 자체를 거부할 수 있으며 이에 대해 회사는 어떠한 책임도 지지 않습니다.
      
          -회사, 타회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우
      
          -공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등 유포에 해당하는 경우
      
          -범죄적 행위에 연계되거나 결부된다고 인정되는 내용일 경우
      
          -회사 저작권, 제3자의 저작권 등 기타 권리를 침해하는 내용일 경우
      
          -회사에서 제공하는 서비스와 관련없는 내용일 경우
      
          -불필요하거나 허가받지 않은 광고, 판촉물을 게재하는 경우
      
          -타인 아이디, 성명 등을 무단도용하여 작성한 내용이거나, 타인의 입력정보를 무단으로 위조, 변조한 내용일 경우
      
          -동일한 내용을 중복하여 게시하는 등 게시 목적에 어긋나는 경우
      
          -불법통신 관련 또는 기타 관계 법령 및 회사지침 등에 위반된다고 판단되는 경우
      
       6) 회사는 게시물에 관련된 세부 이용지침을 별도로 정하여 시행할 수 있으며, 회원은 그 지침에 따라 각 게시물(회원간 전달도 해당)을 등록하거나 삭제하여야 합니다.
      
       7) 회사가 작성한 저작물에 대한 저작권 및 기타 지적재산권은 회사에 귀속합니다. 회원이 서비스내에 게시한 게시물의 저작권은 해당 저작권자에게 귀속합니다.
      
       8) 회원은 서비스를 이용하면서 얻은 정보를 회사의 허락 없이 영리목적으로 이용하거나 제3자에게 이용하게 할 수 없습니다.
      
       9) 회원은 회사의 저작물에 대하여 전부 또는 일부의 수정, 대여, 대출, 판매, 배포, 제작, 양도, 재 라이센스, 담보권 설정 행위, 상업적 이용 행위를 할 수 없으며, 제3자로 하여금 이와 같은 행위를 하도록 허락할 수 없습니다.
      
      10) 회원은 본인이 작성하거나 등록한 게시물에 대하여 회사가 아래 행위를 할 수 있도록 사용료 없는 비배타적인 사용권을 회사에게 부여합니다.
      
          -서비스내 회원 게시물 복제·수정·전시·배포·출판 및 2차 저작물과 편집저작물의 작성 등
      
          -미디어, 통신사 등 서비스 제휴 파트너에게 회원의 게시물 제공 및 사용 허용
      
          -기타 회사 홍보 등 목적에 사용
      
      11) 상기 항목의 사용권부여는 회사가 서비스를 운영하는 동안 유효하며, 회원이 탈퇴한 이후에도 회원의 별도요청이 없으면 지속적으로 적용됩니다.
      
      
      제6조 (제공 서비스와 이용요금)
      
       1) 회사는 원거리에 있는 고객의 문제점을 원격으로 빠르게 진단하고 모니터링하여 해결해 줄 수 있는 PCCL 원격지원제어 서비스를 회원에게 제공합니다.
      
       2) 이용요금은 PCCL 홈페이지 (https://www.linkmemine.co.kr) 에 공시합니다.
      
       3) 회사는 상기 서비스 이외 새로운 서비스를 추가로 제공할 수 있으며, 신규 서비스는 본 약관에 의거하여 서비스를 제공합니다.
      
       4) 신규서비스 제공 시 세부이용약관이 있을 경우 개별 서비스 신청시 홈페이지에 공지되며, 본 약관과 상이한 내용은 서비스별 세부 이용약관이 우선 적용됩니다.
      
       5) 초기비용(가입비, 초기설치비 등)는 가입 시 1회 발생하는 비용으로, 서비스 제공에 필요한 환경 구축을 위해 소요되는 비용을 의미합니다.
      
       6) 서비스 이용요금 종류는 아래와 같으며, 회사 정책에 따라 서비스별 추가적인 요금제가 있을 수 있습니다.
      
          -월 이용요금은 서비스 개통일로부터 익월 개통일 1일 이전까지 1개월분 서비스 비용
      
          -년 이용요금은 서비스 개통일로부터 익년 개통일 1일 이전까지 1년분 서비스 비용
      
          -기간 이용요금은 특정 기간 사용 시의 서비스 비용
      
       7) 이용요금 과금은 계약 기반 서비스 개통일로부터이며, 실제로 서비스 이용 여부와 상관없이 서비스 기간에 따라 계산됩니다.
      
       8) 일할 이용요금의 계산은 한국표준시간 기준 00:00부터 23:59까지를 1일로 하며, 서비스 제공의 개시 시간 또는 종료시간이 상기 일일 기준 하루의 중도 시점인 경우 이를 1일로 간주하여 계산합니다.
      
       9) 월 이용요금의 계산은 서비스 개통일로부터 익월 개통일 1일 이전까지를 1개월의 이용요금으로 하며, 연 이용요금의 계산은 서비스 개통일로부터 익년 개통일 1일 이전까지를 1년의 이용요금으로 합니다.
      
      10) 요금 납부는 신용카드결제, 은행자동이체납부, 무통장입금 등 회사에서 제공하는 결제방식을 통해서 가능합니다. 단, 회사 사정상 서비스 단위로 결제수단이 일부 제한될 수 있습니다.
      
      11) 상기 항목의 각 결제수단을 담당하는 결제대행사업자가 별도 존재 시 회원은 결제수단을 이용하기 전에 해당 결제대행사업자가 제시하는 절차를 이행해야 합니다. 회사 서비스 이용요금을 결제할 때, 해당 결제대행사업자가 제시하는 절차 이행 및 이용약관에 동의한 것으로 간주합니다.
      
      12) 무통장입금일 경우 입금인과 신청서 상 입금예정자가 다를 경우 신청자 또는 입금인은 회사에 전화 또는 이메일, 팩스로 그 내용을 통지해야 합니다. 이의 누락으로 인한 모든 책임은 신청자에게 있습니다.
      
      13) 입금 확인은 회사 영업 시간(평상시 월요일에서 금요일까지 오전9시에서 오후6시)내에 이루어지며, 영업종료 후 입금은 익일 처리 완료됩니다.
      
      14) 인앱 결제 기능으로 처리할 경우, 회원은 기기의 비밀번호 설정 및 오픈마켓에서 제공하는 비밀번호 설정 기능 등을 이용하여 불특정 제3자의 인앱 결제를 방지하여야 합니다. 혹 회원이 사용하는 기기나 오픈마켓 비밀번호 설정 기능 등을 사용하지 않거나 부주의하게 노출시켜 발생하는 제3자의 인앱 결제에 대해 회사는 어떠한 책임도 부담하지 않습니다.
      
      15) 유료회원은 서비스 개통 전에 이용요금을 선납부 결제처리하여야 합니다. 결제수단 중 무통장입금 방식 납부 시에는 서비스 이용 신청 완료 후 최대 1주일 이내에 해당 금액을 입금하여야 하며, 1주 내 입금하지 않을 시 회사는 그 신청을 철회할 수 있습니다.
      
      16) 회사는 유료 서비스 이용신청 접수 및 서비스 개통 후 이용요금 영수 또는 청구서를 이용신청서상의 회원에게 우편 또는 이메일, 기타 결제대행 사업자가 제시하는 방법으로 발송할 수 있습니다.
      
      17) 회원이 은행자동이체 납부 방식을 선택한 경우, 회원이 계약 시 제공한 해당일자와 해당계좌에서 계약금액이 자동으로 인출됩니다. 만약 출금계좌로 신청한 통장 잔액이 청구금액보다 부족할 경우 회사는 통장잔액 한도 내 부분출금을 할 수 있으며 납기일 이후 부족분에 대하여 재출금할 수 있습니다.
      
      18) 회사가 회원에게 제공하는 유료서비스는 청약철회 가능 서비스와 청약철회 제한 서비스로 구분되어 제공됩니다. 청약철회가 가능한 서비스는 구매 시부터 7일 이내에 청약 철회를 할 수 있으며, 이 기간이 경과한 서비스이거나 전자상거래 등에서의 소비자 보호에 관한 법률 등 기타 관계법령에서 정한 청약철회 제한 사유에 해당하는 서비스는 청약철회가 제한됩니다. 청약 철회가 제한되는 서비스는 제한되는 사실을 팝업 화면이나 연결 화면 등으로 표시합니다.
      
      19) 회사는 회원이 요금을 과납하거나 오납한 경우 그 요금을 반환하거나 차기 요금에서 정산합니다. 그러나 회원의 고의 또는 귀책 사유로 과오금이 발생한 경우 환불에 소요되는 비용은 합리적인 범위 내에서 회원이 부담하도록 합니다.
      
      20) 회사에게 요금을 지급한 회원에게 환불을 처리해드리는 환불사유는 아래 항목에 나열된 경우에 한합니다. 또한 아래 환불사유 발생 시에도 회원 요청이 있을 경우에 한해 환불이 진행되고 이 때 회사는 잔여 계약 기간에 준하는 요금을 환불합니다.
      
          -회사 귀책사유로 서비스에 중대한 하자가 있어 서비스 이용이 불가능한 경우 및 회사 서버의 문제로 유료회원의 중요 데이터가 영구 삭제된 경우
      
          -회사 귀책사유로 네트워크 서비스의 영구 중단으로 인하여 더 이상 서비스를 할 수 없게 되는 경우
      
      21) 회원이 환불을 요구하는 경우 회사는 구매내역을 확인 후 회원에게 본인확인을 위하여 아래 서류의 제출을 요청할 수 있으며, 회원은 요청하는 서류를 이메일, FAX 등의 방법으로 회사에 즉시 제출해야 합니다.
      
          -해지신청서
      
          -환불요청자 또는 기업 명의의 통장 사본 1부
      
          -환불요청자의 신분 확인 서류 사본 1부 (요건상 필요없다 판단될 경우 받지 않음)
      
          -비용을 납부한 납부 영수증 1부 (요건상 필요없다 판단될 경우 받지 않음)
      
      22) 회사는 유료회원으로부터 상기 서류를 수령하고 최대한 조속한 시일 내 환불을 완료하도록 최선의 노력을 기합니다.
      
      23) 청약철회를 한 경우 회사는 회원 데이터 및 서비스를 회수 또는 삭제하고 삭제한 날로부터 15영업일 이내에 지급받은 대금을 환급합니다. 이 경우 회사가 회원에게 환급을 지연한 때에는 그 지연기간에 대하여 전자상거래 등에서의 소비자보호에 관한 법률 및 시행령에서 정하는 이율을 곱하여 산정한 지연이자를 지급합니다. 회사는 이미 재화 등이 일부 사용되거나 일부 소비된 경우에는 그 재화 등의 일부 사용 또는 일부 소비에 의하여 회원이 얻은 이익 또는 그 재화 등의 공급에 든 비용에 상당하는 금액을 회원에게 청구할 수 있습니다. 회원이 청약철회를 한 경우 재화 등의 반환에 필요한 비용은 회원이 부담하나 회사는 회원에게 청약철회를 이유로 위약금 또는 손해배상을 청구할 수 없습니다.
      
      24) 유료회원은 회사에서 발송한 청구내역에 이의가 있을 시, 회사에 이의신청을 제기할 수 있으며, 회사는 접수한 이의신청 결과를 접수 후 48시간 이내 이의신청한 유료회원에게 회신합니다.
      
      25) 회사는 유료회원 이의신청에 대한 회신이 48시간 이내 어려울 경우, 회신 가능한 일정을 유료회원에게 통보하고, 회사는 유료회원에게 이로 인한 불이익이 발생하지 않도록 조치합니다.
      
      26) 유료회원이 납부한 요금에 과납 또는 오납이 있을 경우, 회사는 이를 유료회원에게 유선 또는 이메일로 통지하며, 유료회원은 회사가 안내하는 절차에 따라 요금 정산을 합니다.
      
      
      제7조 (회원의 서비스 이용 제한)
      
       1) 회원은 회사에서 제공받은 서비스를 제3자에게 재판매할 수 없습니다. 단, 재판매 목적으로 별도 계약이 체결된 경우는 제외합니다
      
       2) 회원은 회사에 게시된 타 정보의 변경을 할 수 없고 회사 및 기타 제3자의 저작권 등 지적재산권을 침해할 수 없습니다. 또한 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시를 할 수 없습니다.
      
       3) 회원은 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위를 할 수 없습니다.
      
       4) 회사는 회원이 아래 내용에 해당하는 경우, 해당 내용을 제8조에 기술된 회원에 대한 통지 방법 또는 기타 유효한 수단을 통해 해당 회원에게 통지하고 해당 사유가 해소될 때까지 회원의 서비스 이용을 중지시키거나 제한할 수 있습니다.
      
          -사회적 공익을 저해하거나 미풍양속에 반하는 행위에 해당하는 경우
      
          -타인의 명예를 손상시키거나 타인에게 불이익을 주는 행위
      
          -안정된 서비스 운용을 저해할 수 있는 다량의 정보전송, 해킹(크래킹), 컴퓨터 바이러스 프로그램 유포, 광고성 정보를 전송 및 매개하는 행위 등
      
          -리버스엔지니어링, 디컴파일, 디스어셈블 및 기타 일체의 가공행위를 통하여 “서비스”를 복제, 분해 또는 모방 기타 변형하는 행위
      
          -회사의 승인을 받지 아니한 광고, 스팸메일, 행운의 편지, 다단계판매 및 기타 다른  형태의 권유를 게시, 게재, 이메일 또는 기타의 방법으로 전송하는 행위
      
          -타인의 특허, 상표, 영업비밀, 보호할만한 가치가 있는 권리, 저작권, 기타 지적 재산권을 침해하는 내용을 게시, 게재, 이메일 또는 기타의 방법으로 전송하는 행위
      
          -다중회원 가입 및 이용신청 시에 허위내용을 등록한 경우
      
          -다른 회원의 아이디 또는 명의를 도용한 경우
      
          -기타 관련 법령이나 본 약관이 정한 이용조건에 위배되는 경우
      
       5) 회원이 서비스를 계약해지하고자 할 경우에는 해당 본인이 회사에서 별도로 홈페이지를 통해 해지할 수 있도록 되어 있는 경우 사이트 상에서 진행하거나 또는 그 외 회사가 정한 별도의 이용방법으로 회사에 해지신청을 하여야 합니다.
      
       6) 회사는 회원이 본 약관에 규정한 회원의 의무를 이행하지 않을 경우 사전 통지 없이 이용계약을 해지하거나 서비스 이용을 중지할 수 있습니다. 이 경우 회원은 회사가 정한 절차에 따라 이의신청을 할 수 있으며 회사가 이를 정당하다고 인정할 경우 즉시 서비스 이용을 재개합니다.
      
       7) 회사는 회원이 이용계약을 체결하여 아이디와 비밀번호를 부여받은 후에라도 회원의 자격에 따라 서비스 이용을 제한할 수 있습니다.
      
      
      제8조 (회사 및 회원의 권리와 의무)
      
       1) 회사는 업무상·기술상 지장이 없는 한 연중 무휴 1일 24시간 서비스를 이용할 수 있는 것을 원칙으로 하되 서비스를 위해 실시하는 시스템 점검이나 기타 회사의 필요한 정기 또는 비정기 점검시간은 제외하며 이 때 서비스의 일부 또는 전부 사용이 제한될 수 있습니다.
      
       2) 회사는 명백하게 서비스를 제공할 수 없는 사정이 발생하지 않는 한 이용자가 신청한 서비스 개통 희망일에 서비스를 이용할 수 있도록 합니다.
      
       3) 회사는 이용자로부터 제기되는 서비스에 대한 불만이나 의견이 정당하다고 인정될 경우 최대한 신속하게 처리하여야 합니다. 단, 빠른 처리가 어려울 때 이용고객에게 그 사유와 처리일정을 이메일 또는 유선 등으로 통보합니다.
      
       4) 회사는 서비스 제공과 관련하여 취득한 회원정보를 본인의 사전 승낙 없이 타인에게 배포할 수 없습니다. 단, 법령에 근거한 관계기관으로부터 요구받은 경우 또는 회사가 정한 기간 동안 이용요금을 체납하는 경우에는 회원에게 통보 후 신용정보사업자 또는 신용정보집중기관 등에 제공하는 경우 등에 예외적으로 사용할 수 있습니다.
      
       5) 회원은 회원가입 신청 시 모든 사항을 사실에 근거하여 기재해야 하며, 허위 또는 타인의 정보를 등록할 경우 일체의 권리를 주장할 수 없습니다.
      
       6) 회사가 제공하는 서비스를 이용함에 있어 아래 행위는 금지됩니다.
      
          -회원가입 신청이나 회원정보 변경 시 허위사실을 기재하거나, 다른 회원의 아이디 및 비밀번호를 도용, 부정하게 사용하는 행위
      
          -회원의 아이디나 계정을 타인과 거래하는 행위
      
          -타인의 명예를 손상시키거나 불이익을 주는 행위
      
          -게시판 등에 음란물을 게재하거나 음란사이트를 연결(링크)하는 행위
      
          -회사의 지적재산권, 제3자의 지적재산권 등 기타 권리를 침해하는 행위
      
          -공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형, 음성 등을 타인에게 유포하는 행위
      
          -프로그램의 버그를 악용하여 서비스를 이용하는 행위
      
          -서비스 운영을 고의로 방해하는 행위
      
          -회사에 게시된 정보의 변경 및 회사가 정한 정보 이외의 컴퓨터 프로그램 등을 포함한 정보의 송신 또는 게시행위
      
          -컴퓨터프로그램, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 이메일로 발송하는 행위
      
          -회사의 승인을 받지 않고 다른 회원의 개인정보를 수집 또는 저장하는 행위
      
          -회사의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의 명의를 도용하여 글을 게시하거나 이메일을 발송하는 행위
      
          -기타 불법적이거나 부당한 행위
      
       7) 회원은 관계법령, 본 약관 규정, 이용안내 및 주의사항 등 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하지 않아야 합니다.
      
       8) 회원은 서비스 이용에 대한 대가로서 본 약관에서 정한 이용요금을 납부할 의무가 있으며 서비스 이용요금 미납으로 인해 발생되는 모든 문제에 대한 책임은 회원에게 있습니다. 단, 명백한 회사의 과실이 있거나 별도 회사가 인정한 사유 시는 그렇지 않습니다.
      
       9) 회원은 서비스 신청 당시의 고객정보에 변경이 발생하면 즉시 그 내용을 회사에 통보하여야 하며, 통보 지연으로 발생한 문제에 대해서는 회사에서 책임을 지지 않습니다.
      
      10) 회원이 회사 서비스 장애를 초래하게 했을 경우 복구, 보충, 수선 또는 기타 공사에 소요되는 비용과 이로 인해 발생되는 회사 손해를 전액 부담해야 합니다.
      
      11) 회원이 제공하는 모든 정보의 저작권과 관련하여 발생하는 문제는 회원의 책임입니다.
      
      12) 이용요금을 선불로 납부한 서비스를 타인에게 양도 또는 재판매할 수 없으며 회사는 회원에게 제공된 아이디와 패스워드를 현금 또는 기타 유가증권으로 교환해 줄 수 없습니다.
      
      13) 회원은 서비스 이용권한, 기타 이용계약상의 지위를 타인에게 양도 및 증여할 수 없습니다.
      
      14) 회원 아이디는 원칙적으로 변경이 불가하며 회원은 보유계정의 아이디 및 비밀번호 관리를 철저히 하여야 합니다. 회원 아이디와 비밀번호 관리 소홀 및 부정 사용에 의하여 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다. 회원은 본인이 아이디와 비밀번호를 제3자에게 이용하게 해서는 안 되며, 회원 본인의 아이디와 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지하는 경우에는 즉시 회사에 통보하고 회사의 안내가 있는 경우 이에 따라야 합니다.
      
      15) 회원은 서비스 이용권한 및 서비스 이용계약상의 지위는 제3자에게 양도하거나 대여할 수 없으며 또한 담보로 제공할 수 없습니다. 회사는 회원이 이러한 행위를 하였을 경우 회원의 서비스 이용을 제한할 수 있으며, 회원의 상기 행위로 야기된 결과에 대한 책임은 회원에게 있습니다.
      
      16) 회원 대상 고지를 위해 회사는 회원이 회사에 제출한 이메일 주소 또는 연락처(전화번호, 휴대폰번호) 등을 사용해 진행할 수 있습니다. 불특정다수 회원에 대한 통지의 경우 홈페이지 및 해당 서비스 게시판 등에 게시함으로써 개별 통지를 갈음할 수 있습니다.
      
      17) 회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있으나 서비스 관리를 위해 필요한 실명·아이디 등은 수정이 불가능합니다.
      
      18) 회원은 회원가입 신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 이메일 등을 이용해 회사에 그 변경사항을 알려야 합니다. 회원이 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.
      
      19) 회사는 ‘개인정보보호법’ 등 관련법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다.
      
      20) 회원의 개인정보보호에 관해서는 관련 법령 및 회사의 개인정보처리방침이 적용됩니다. 단, 회사의 공식 사이트 이외의 웹에서 링크된 사이트에서는 회사의 개인정보처리방침이 적용되지 않습니다. 또한 회사는 회원의 귀책사유로 인해 노출된 정보에 대해서 일체의 책임을 지지 않습니다.
      
      
      제9조 (손해배상 및 면책, 분쟁해결)
      
       1) 회원이 본 약관의 규정을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 이 약관을 위반한 회원은 회사에 발생하는 모든 손해를 배상하여야 합니다.
      
       2) 회원이 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반행위로 인하여 회사가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받은 경우 당해 회원은 자신의 책임과 비용으로 회사를 면책 시켜야 하며, 회사가 면책되지 못한 경우 당해 회원은 그로 인하여 회사에 발생한 모든 손해를 배상하여야 합니다.
      
       3) 회사는 무료로 서비스(테스트 목적 서비스 포함) 제공된 기간 중에 발생한 손해 또는 서비스 요금이 무료인 서비스 이용과 관련하여 회원에게 발생한 손해에 대하여 어떠한 책임도 지지 않습니다.
      
       4) 회사는 유료회원으로부터 서비스를 이용하지 못한 사실을 접수한 시간 (또는 회사가 인지한 시간)부터 서비스 재개를 위한 가능한 조치를 취하며, 서비스를 다시 이용할 수 있게 된 경우 이 사실을 유료회원에게 통지합니다. 다만, 유료회원이 서비스 이용불가 사실을 회사에 접수한 이후 4시간 이내 서비스가 정상화된 경우는 제외합니다.
      
       5) 회사의 명백한 귀책사유로 유료회원이 서비스를 이용하지 못하는 경우에는 유료회원이 그 사실을 회사에 통보하여 회사가 확인한 때로부터 계속 4시간 이상 서비스를 제공받지 못하거나 월 장애누적시간이 12시간을 초과한 경우에 대하여 정회원의 최근 3개월(3개월 미만인 경우에는 해당기간 적용)의 1일 평균요금에 서비스 제공중지시간을 24로 나눈 수를 곱하여 산출한 금액의 3배의 금액 또는 그에 상당하는 서비스 기간 연장을 통하여 배상합니다. 중단시간의 합산시 끝으로 남은 시간이 30분이상 1시간 미만인 경우에는 1시간으로 합니다.
      
       6) 회사에 대한 손해배상의 청구는 회사에 청구사유, 청구금액 및 산출근거를 기재하여 서면으로 해야 하며, 발생한 날로부터 3개월이 경과한 경우에는 회사에 대해 손해배상을 청구할 수 있는 권리는 소멸됩니다.
      
       7) 회사는 국가의 비상사태, 천재지변 또는 이에 준하는 국가비상사태 등 불가항력으로 서비스를 제공할 수 없는 경우 서비스 제공에 대한 책임을 지지 않습니다.
      
       8) 회원의 고의 또는 과실 등 회원의 귀책사유로 인한 서비스의 이용장애에 대해 책임을 지지 않습니다.
      
       9) 전기통신서비스 특성상 불가피한 사유로 서비스 제공이 불가능하거나 서비스 제공 관련 시스템의 변경, 교체, 업데이트 등을 위하여 일시적으로 서비스 제공이 중단되는 경우 책임을 지지 않습니다.
      
      10) 회원의 귀책사유로 서비스가 해지되어, 회원의 정보가 소실된 경우 책임을 지지 않습니다.
      
      11) 회원이 회사의 서비스 제공으로부터 기대되는 이익을 얻지 못하였거나, 서비스로부터 수반되는 잠재가치 및 서비스 자료에 대한 취사선택 또는 이용으로 손해가 발생한 경우 책임을 지지 않습니다.
      
      12) 회원이 게시 및 보관 또는 전송한 자료(정보와 자료의 신뢰도, 정확성, 해당 자료로부터 발생하는 모든 바이러스, 스파이웨어 및 기타 악성 프로그램과 기타 문제 포함)에 대해서는 회사의 책임이 면제되며, 회사는 책임을 지지 않습니다.
      
      13) 회사는 회원 상호간 또는 회원과 제3자 상호간에 서비스를 매개로 하여 거래 등을 한 경우 해당 거래 등으로 인해 발생하는 손해나 손실에 대해 책임지지 않습니다.
      
      14) 회사는 회원과 제3자 상호간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며 이로 인한 손해를 배상할 책임도 없습니다.
      
      15) 회원과 회사는 서비스 이용과 관련해 발생한 문제를 원만하게 해결하기 위해 상호 성실히 협의합니다.
      
      16) 본 조 제1항의 협의에도 불구하고, 분쟁으로 인해 소송이 제기될 경우 회사의 소재지 법원을 관할법원으로 합니다.
      
      17) 회사와 이용자간에 제기된 소송에는 대한민국 법을 적용합니다.
      
      
      부칙
      
      제 1조 (시행일) 이 약관은 2023년 11월 15일부터 시행합니다.
    `,
    'agree_privacy': '개인정보 수집/이용에 대한 동의',
    'agree_privacy_context': `
      [PCCL 개인정보취급방침]
      
      
      pCloud(이하 '회사')에서 운영하는 모든 서비스는 이용자의 권리보호를 위해 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 회사는 『개인정보보호법』 제30조에 따라 회원의 개인정보 처리에 대한 절차 및 기준을 안내하여 관련업무를 신속하고 원활하게 처리할 수 있도록 고지하며 『개인정보보호법』등 모든 관련법규를 준수하고 있습니다.
      
      서비스 회원 개인정보보호정책은 관련법률 및 지침의 변경과 서비스 사이트(이하 ‘사이트’) 내부 운영규칙이 변경됨에 따라 바뀔 수 있습니다. '사이트'의 회원 개인정보보호정책이 변경될 경우 변경사항은 '사이트'에 게시됩니다.
      
      
      1. 개인정보의 수집범위
      
      1) 회사는 회원가입 또는 서비스 이용 과정에서 홈페이지 또는 어플리케이션이나 프로그램 등을 통해 서비스 제공을 위하여 필요한 개인정보를 최소한으로 수집하고 있습니다.
      
      2) 이용자에게 서비스 제공을 위해 반드시 필요한 최소한의 정보를 필수항목으로, 그 외 특화된 서비스를 제공하기 위해 추가 수집하는 정보는 선택항목으로 동의를 받고 있으며, 선택항목에 동의하지 않은 경우에도 서비스 이용 제한은 없습니다.
      
        - 필수항목: 아이디, 이름, 생년월일, 이메일, 휴대폰번호, 회사명, 회사전화번호, 담당자명
      
        - 선택항목: 회사 홈페이지, 팩스번호, 부서명, 직책
      
      3) 그 외 서비스 페이지 내 이벤트 참여 및 경품 신청 과정에서 추가 개인정보 수집이 발생할 수 있으며 추가로 개인정보를 수집할 경우에는 해당 개인정보 수집 시점에서 이용자에게 ‘수집하는 개인정보 항목, 개인정보의 수집 및 이용목적, 개인정보의 보관기간’에 대해 안내하고 동의받는 절차를 가집니다.
      
      4) 보호를 요하는 만 14세 미만 이용자의 개인정보 수집 시 대상아동에게 법정대리인의 성명, 연락처와 같이 최소한의 정보를 요구할 수 있고, 적법한 법정대리인이 동의하였는지를 확인하기 위해 아래의 한 방법으로 처리합니다.
      
        가.동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 개인정보처리자가 동의 표시를 확인했음을 법정대리인 휴대전화 문자메시지로 알리는 방법
      
        나.동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 신용카드, 직불카드 등의 카드정보를 제공받는 방법
      
        다.동의 내용을 게재한 인터넷 사이트에 법정대리인이 동의 여부를 표시하도록 하고 법정대리인의 휴대전화 본인인증 등을 통해 본인 여부를 확인하는 방법
      
        라.동의 내용이 적힌 서면을 법정대리인에게 직접 발급하거나, 우편 또는 팩스를 통하여 전달하고 법정대리인이 동의 내용에 대해 서명날인 후 제출하도록 하는 방법
      
        마.동의 내용이 적힌 전자우편을 발송하여 법정대리인으로부터 동의 의사표시가 적힌 전자우편을 전송받는 방법
      
        바.전화를 통하여 동의 내용을 법정대리인에게 알리고 동의를 얻거나 인터넷주소 등 동의 내용을 확인할 수 있는 방법을 안내하고 재차 전화 통화를 통하여 동의를 얻는 방법
      
        사.그 밖에 위와 준하는 방법으로 법정대리인에게 동의 내용을 알리고 동의의 의사표시를 확인하는 방법
      
      
      2. 개인정보 수집에 대한 동의
      
      '사이트'는 이용자가 '사이트'의 개인정보보호방침 또는 이용약관의 내용에 대해 「동의한다」 또는 「동의하지 않는다」를 선택할 수 있는 절차를 마련하여, 「동의한다」를 선택할 경우 개인정보 수집에 대해 동의한 것으로 봅니다.
      
      
      3. 개인정보의 처리목적
      
      회사는 아래 목적을 위해 개인정보를 처리하며 처리하고 있는 개인정보는 아래 목적 이외의 용도로는 이용되지 않습니다. 이용목적이 변경되는 경우에 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
      
      가. 서비스 제공 관련 계약 이행
      
        - 서비스 및 콘텐츠의 제공, 유지 및 관리 보호, 구매 및 요금 결제
      
      나. 이용자 관리
      
        - 서비스 제공, 개인 식별, 불량사용자의 부정 이용방지와 비인가 사용방지, 분쟁 조정을 위한 기록보존, 기술지원 등 민원처리, 고지사항 전달, 서비스 탈퇴 의사 확인
      
      다. 서비스 개선 요소 파악 자료 활용
      
        - 서비스 개선 및 신규 서비스 개발, 이용자 경험 및 기능 개선, 신규 서비스/제품 개발 및 특화부분 파악, 접속 빈도 파악 또는 이용자의 서비스 이용에 대한 통계 분석
      
      라. 마케팅 및 광고 활용
      
        - 인구통계학적 특성에 따른 서비스 제공 및 광고게재, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공
      
      
      4. 개인정보의 제3자 제공 및 처리 위탁
      
      가. 회사는 이용자 개인정보를 개인정보 처리 목적에서 명시한 범위 내에서 처리하며, 이용자의 동의 및 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 이용자 개인정보를 제3자에게 제공하지 않는 것을 원칙으로 하나 아래의 경우에는 예외로 합니다.
      
        - 법령의 규정에 의거하나, 수사·조사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관 및 감독 당국의 요구가 있는 경우
      
        - 이용자가 사전 공개 또는 제3자 제공에 동의한 경우
      
        - 통계작성, 학술 연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우
      
        - 그 밖에 개인정보 제3자 제공이 필요시 합당한 절차를 통한 이용자 제3자 제공 동의를 얻은 경우
      
      나. 회사는 서비스와 관련하여 당사가 직접 취급이 어려운 결제 기능 등 전문업체가 필요한 경우 서비스 이행처리를 위해 개인정보를 위탁하고 있습니다. 회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다. 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.
      
        - 서비스 결제(PG) 위탁기관 : 토스페이먼츠(주)
      
        - 위탁업무 내용 : 구매 및 요금 결제, 금융거래 본인인증 및 금융 서비스
      
      
      5. 개인정보의 파기
      
      가. 회사는 개인정보 보유기간 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때 지체없이 해당 개인정보를 파기합니다.
      
      나. 이용자에게 개인정보 보유기간에 대해 별도 동의를 얻은 경우에는 해당 기간 동안 개인정보를 안전하게 보관합니다. 개인정보 보유기간에 대해 개인정보 수집 시 동의를 얻은 경우 보관기한은 아래와 같습니다.
      
        - 여러 형태의 온라인 문의 창구로 수집된 개인정보 : 수집시점으로 1년 보관
      
        - 데모가입 및 무료체험 시 수집된 개인정보 : 수집시점으로 1년 보관
      
        - 서비스 이용기록 : 수집시점으로 1년 보관
      
        - 환불요청시 수집된 개인정보 : 환불처리 완료 후 지체없이 파기
      
      다. 동의된 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스로 옮기거나 보관장소를 달리하여 보존합니다.
      
      라. 서비스 종료 또는 법령에서 보존의무를 부과한 항목의 보존기간 경과 및 회원탈퇴 등 이용자에게 동의받은 개인정보의 보유기간의 도래 시 개인정보 수집 및 이용목적이 달성된 개인정보는 재생이 불가능한 방법으로 파기합니다.
      
        - 파기 사유가 발생한 개인정보를 선정하고, 회사 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
      
        - 전자적 파일 형태로 기록∙저장된 개인정보는 기록을 재생할 수 없도록 파기하고 종이 문서에 기록∙저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
      
      
      6. 이용자 (법정 대리인 포함) 권리 의무 및 행사
      
      가. 서비스 이용자는 회사의 개인정보관리책임자에게 서면 및 이메일로 연락하여 개인정보의 열람·수정·탈퇴 등 권리를 행사할 수 있습니다.
      
      나. 이용자가 개인정보 오류에 대한 정정을 요청한 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용하거나 제공하지 않는 것을 원칙으로 합니다. 잘못된 개인정보가 제3자에게 이미 전달된 경우 정정된 내용을 제3자에게 지체없이 통지하도록 처리합니다.
      
      다. 회사는 이용자 요청에 의해 해지 또는 삭제된 개인정보는 개인정보 처리 및 보유기간에 명시된 바에 따라 처리하고 그 외 용도로 열람 또는 이용할 수 없게 처리하고 있습니다.
      
      라. 열람청구의 방법
      
        - 본 개인정보 처리방침내 “개인정보보호책임자”에서 안내되는 담당자 이메일로 요청,  방법 및 절차: 이메일 접수 -> 청구자 본인 또는 법정대리인 확인 -> 요청자료 제공
      
      마. 열람·수정을 요청할 수 있는 사항
      
        - 회사가 보유하고 있는 본인의 개인정보
      
        - 회사가 고객의 개인정보를 이용하거나 제3자에게 제공한 현황
      
        - 본인이 동의한 개인정보의 수집·이용·제공현황
      
      
      7. 개인정보의 보안성 확보조치
      
      회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않는 안전성 확보를 위하여 기술적인 부분과 관리적인 부분에서 아래와 같이 대비하고 있습니다.
      
      가. 해킹 대응 : 회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원 개인정보가 유출되거나 훼손되는 것을 막기 위해 노력하고 있습니다. 주기적인 자료백업과 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지 않도록 방지하고 있으며, 암호화 기술을 활용하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템 등을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 기술적 장치를 갖추기 위해 노력하고 있습니다.
      
      나. 개인정보 처리 내부규칙 준수 : 회사의 개인정보관련 처리 직원은 담당자에게 한정시키며 별도의 비밀번호 및 정기적 갱신과 담당자 수시 교육을 통하여 개인정보 처리방침의 준수를 하기 위해 노력하고 있습니다. 또한 개인정보 관련 처리자의 업무 인수인계는 보안이 유지된 상태에서 철저하게 이루어지고 있으며 입사와 퇴사와 같은 상황변수도 고려하여 책임의 누수를 대비하고 있습니다.
      
      다. 개인정보보호교육 및 의식 고취 : 입사 시 전 직원의 보안서약서를 통하여 인력에 의한 정보유출을 사전에 방지하고 사내 개인정보보호교육 등을 통해 개인정보 처리방침의 이행사항 및 담당자의 준수여부를 확인하여 문제가 발견될 경우 즉시 수정하고 바로 잡을 수 있도록 하고 있습니다. 단, 이용자 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호 등 개인정보가 유출되어 발생한 문제는 이용자 개인이 책임질 문제이므로 주의하시기 바랍니다.
      
      
      8. 개인정보 자동 수집 장치 운영 및 거부 관련
      
      회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.
      
      가. 인터넷에서 사용되는 쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다. 이후 웹 사이트에 방문할 경우 웹 사이트 서버는 이용자의 하드 디스크에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제공하기 위해 이용됩니다. 쿠키는 개인을 식별하는 정보를 자동적·능동적으로 수집하지 않으며, 이용자는 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다.
      
      나. 쿠키 사용 목적은 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태 등을 파악하여 이용자에게 최적화된 정보 제공을 위해서입니다.
      
      다. 대표적인 브라우저들의 쿠키 거부 설정 방법은 아래와 같습니다.
      
       - Microsoft Edge: (Edge 설정→쿠키 및 사이트 권한→쿠키 및 사이트 데이터 관리 및 삭제→사이트에서 쿠키 데이터를 저장하고 읽도록 허용 ‘비활성화’)
      
       - Chrome 이용자: (Chrome 설정→고급→개인정보 보호 및 보안→콘텐츠 설정→ 쿠키→ 사이트에서 쿠키 데이터 저장 및 읽기 허용 ‘사용중지’)
      
      라. 회사는 당사 서비스를 사용하는 이용자가 당사 서비스를 사용하는 방법에 대해 분석 및 평가하고 서비스와 제품을 개선하며 개인화방법을 통해 이용자에게 효율적인 서비스를 제공하기 위한 사용자 요구를 파악하기 위해 분석 서비스를 사용합니다. 분석 서비스에서 수집한 모든 정보는 분석 서비스 사업자의 개인정보보호 정책에 따라 처리됩니다.
      
      
      9. 개인정보보호책임자 및 담당부서
      
      회사는 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등 개인정보 처리 업무를 총괄 처리하기 위해 아래와 같이 개인정보보호책임자를 지정하여 운영하고 있습니다.
      
      - 개인정보보호책임자 : 오창건 실장 / 기획총괄
      
      - 연락처 : cej@koino.net
      
      
      10. 권익침해 구제방법
      
      가. 이용자는 개인정보침해 구제를 위해 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에서 분쟁해결 또는 상담 등을 신청할 수 있습니다. 기타 개인정보침해의 신고, 상담에 대하여는 아래 기관에 문의하시기 바랍니다.
      
      – 개인정보분쟁조정위원회(https://www.kopico.go.kr / 국번없이 1833-6972)
      
      – 개인정보침해신고센터(https://privacy.kisa.or.kr / 국번없이 118)
      
      – 대검찰청(https://www.spo.go.kr / 국번없이 1301)
      
      – 경찰청(https://ecrm.police.go.kr / 국번없이 182)
      
      나. 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정·삭제), 제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분 또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라 행정심판을 청구할 수 있습니다.
      
      – 중앙행정심판위원회(https://www.simpan.go.kr / 국번없이 110)
      
      
      11. 개인정보 처리방침 변경 및 고지
      
      개인정보 처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 “공지사항”을 통해 고지합니다. 개인정보의 수집 및 활용, 제3자의 제공 등과 같이 이용자 권리의 중요한 변경이 있을 경우에는 최소 30일 전에 고지합니다.
      
      – 공고일자 : 2023년 11월 15일
      
      – 시행일자 : 2023년 11월 15일
    `,
  },
  'help_otp': `
    <h5>Google OTP를 이용한 2단계 인증설정</h5>
    <section style="margin:30px 0;">
      <h6>1. 2단계 인증(OTP)를 활성화</h6>
      <p style="margin-left: 12px;">활성화 버튼을 클릭하여 녹색으로 활성화 시킵니다.<br>
      OTP 재설정 버튼을 클릭합니다.</p>
    </section>
    <section style="margin:30px 0;">
      <h6>2. Google Play Store, 애플 App Store에서 "Google OTP"를 설치합니다.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>3. Google OTP를 실행합니다.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>4. PCCL 관리자 로그아웃 후 다시 로그인 시도를 하면 Google OTP 등록창이 나타납니다.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>5. Google OTP 앱에서 바코드 스캔을 선택하여 등록합니다.</h6>
    </section>
    <section style="margin:30px 0;">
      <h6>6. 인증번호 6자리를 입력 후 로그인합니다.</h6>
    </section>`,
  'help_manager': `
    <h5>중간관리자 권한이란?</h5><br>
    <b>중간관리자(승인자)</b> : 사용자 권한을 포함하고, 사용자의 원격제어 승인요청을 허가/거절할 수 있는 권한<br><br>
    <b>사용자(요청자)</b> : 관리자 또는 중간관리자로부터 원격제어 권한을 승인받아 에이전트를 원격제어 및 모니터링 할 수 있는 권한
  `,
  'help_vaccine': `
    <h5>프로세스/서비스 도움말</h5><br>
    <h6>
      설정한 프로세스/서비스 명(.exe 제외)을 <br>입력하세요.
    </h6>
    <h6 style="padding:0 0 20px 0;">(프로세스/서비스 미사용시 빈칸입력)</h6>
  `,
  'help_os': `
    <h5>OS버전 도움말</h5><br>
    <h6 style="padding:0 0 20px 0;">
      사용하실 OS의 버전을 아래에서 확인 후 입력하세요.<br>
    </h6>
    <table>
      <th>OS</th>
      <th style="padding-right:20px;">MajorVersion</th>
      <th>MinorVersion</th>
      <tr>
        <td>Window Server 2019</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window 10</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2016</td>
        <td style="text-align:center;">10</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Server 2012 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8.1</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">3</td>
      </tr>
      <tr>
        <td>Window 8</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2012</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window 7</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008 R2</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window Server 2008</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Vista</td>
        <td style="text-align:center;">6</td>
        <td style="text-align:center;">0</td>
      </tr>
      <tr>
        <td>Window Home Server</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window Server 2003</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP Professional x64 Edition</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">2</td>
      </tr>
      <tr>
        <td>Window XP</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">1</td>
      </tr>
      <tr>
        <td>Window 2000</td>
        <td style="text-align:center;">5</td>
        <td style="text-align:center;">0</td>
      </tr>
    </table>
  `,
  'help_email': `
    <h5>Email & 전화번호, 반드시 입력하는 이유는?</h5><br>
    <div style="margin-left: 12px;">1. 아이디 및 비밀번호 찾기</div>
    <div style="margin-left: 12px;">2. 휴면 및 잠김 계정 해제</div><br>
    기능을 활용하기 위해 필요합니다.
  `,
  'help_searchPW': `
    등록된 이메일 주소로 비밀번호 재설정 메일이 발송됩니다.
  `,
  'ip_delete_all_warning': '아이피리스트를 전체 삭제하시겠습니까?',
  'ip_delete_all': 'IP 전체삭제',
  'ip_block_reject': `차단정책에 의해 차단된 IP입니다.<br>관리자에게 문의하세요.`,
  'ip_white_reject': `허용정책에 의해 차단된 IP입니다.<br>관리자에게 문의하세요.`,
  'search_manager_200': `승인자가 설정되었습니다.`,
  'search_manager_405': `승인자의 아이디를 확인해주세요.`,
  'search_approver_null': '빈칸입력시 관리자가 승인자로 자동설정됩니다.',
  'date_validate_error': '신청날짜를 확인해주세요.',
  'approvals_reason': '신청사유를 입력하세요',
  'search_approver_placeholder': '승인자 ID를 입력하세요',
  'approval-success': `
    접근권한 요청이 처리되었습니다.
  `,

  'function-settings-desc01': '중간관리자 및 사용자 파일 전송 기능을 허용/차단합니다.',
  'blocking-settings-desc01': '차단 IP를 등록하여 접속을 차단합니다.',
  'blocking-settings-desc02': '허용 IP를 등록하여 등록된 IP만 접속을 허용합니다.',
  'function-submit': '기능설정이 수정되었습니다.',
  'blocking-submit': '차단/허용 설정이 수정되었습니다.',
  'blocking-super-settings-desc': '접속 IP 관리 설정을 사용합니다.',
  'reset-pw-repeat': '비밀번호를 초기화 하시겠습니까?',
  'reset-pw-submit': '비밀번호가 초기화되었습니다.<br>비밀번호 : {password}',
  'registration-access': '접근권한요청이 승인완료되었습니다.',
  'registration-reject': '접근권한요청이 반려되었습니다.',
  'registration-access-error': '반려사유 입력시 접근권한요청을 승인할 수 없습니다.',
  'registration-reject-error': '반려사유를 입력하세요.',
  'login_failed_cause_ip_reject': 'IP 제한 정책에 의해 차단되었습니다.',
  'login_failure_limit': '로그인 실패 허용횟수를 초과하였습니다.<br>담당자에게 문의 또는 메일 인증해주세요.',
  'registration-approve': '처리하기',
  'registration-reject-history': '승인내역을 반려하시겠습니까?',
  'help_ip_add': `
    <h5>IP 추가 도움말</h5><br>
    <h6 style="font-weight:bold;">
      단일 IP 추가
    </h6>
    <h6 style="padding:0 0 20px 0;">입력한 단일 IP 주소만 추가됩니다</h6>
    <h6 style="font-weight:bold;">
      IP 범위 추가
    </h6>
    <h6 style="padding:0 0 20px 0;">
      입력한 시작주소와 끝주소 사이에 포함되는 IP 주소가 추가됩니다.<br>
      예) 192.168.0.0 ~ 192.168.0.255
    </h6>
    <h6 style="font-weight:bold;">
      서브넷팅 추가
    </h6>
    <h6 style="padding:0 0 20px 0;">
      서브넷팅으로 분할된 IP 주소가 추가됩니다.<br>
      예) 192.168.32.0/24
    </h6>
    <h6 style="font-weight:bold;">
      Excel로 추가
    </h6>
    <h6 style="padding:0 0 20px 0;">
      아래 <span style="color:#38d2b8;font-weight:bold;">'Excel 양식 다운로드'</span>를 클릭하여 양식을 다운로드 받은 후
      내용을 입력하고 업로드하세요.<br><br>
      단일 IP와 subnet IP로 추가할 수 있으며,<br>
      시작주소에 IP를 입력하고, 끝주소는 비워주세요.<br><br>
      범위 IP로 추가하는 경우 시작주소와 끝주소를 입력해주세요.<br><br>
      올바르게 입력된 IP주소만 추가됩니다.
    </h6>
  `,
  'ip_range_error': 'IP 주소를 확인해주세요.<br><br>',
  'ip_range_blank': 'IP 주소를 입력하세요.',
  'ip_excel_no_file': 'Excel 파일을 업로드해주세요.',
  'user_in_group_add': '추가할 사용자 아이디를 입력하세요',
  'user_in_group_no_exist': '존재하지 않는 사용자입니다',
  'user_in_group_overlap': '이미 그룹에 속해있는 사용자입니다',
  'user_in_group_blank': '추가할 사용자 아이디를 입력하세요',
  'user_in_group_add_success': '사용자가 그룹에 추가되었습니다',
  'user_in_group_remove_success': '사용자가 그룹에서 삭제되었습니다',
  'start_time_ch': '시작 날짜 선택',
  'start_time_time': '시작 시간 선택',
  'end_time_ch': '종료 날짜 선택',
  'end_time_time': '종료 시간 선택',
  'auth_failure_num_desc': '관리자가 설정한 횟수 이상 로그인 실패시 계정이 잠김 상태로 변경됩니다.',
  'auto_block_time': '원격 접속 후 설정한 시간 이상 사용을 안할 경우 자동으로 원격을 종료합니다.',
  'os_version_desc': '사용자의 접속 환경을 체크하여 정책 설정 상위 버전의 Windows 접속만 허용합니다.',
  'session_timie_desc': '원격 접속 후 설정한 시간 이상 초과시 자동으로 원격을 종료합니다. (사용 중에도 강제 종료)',
  'password_level_desc': '사용자를 생성할 때 비밀번호 난이도를 조정합니다.',
  'capture_desc': '중간관리자 및 사용자의 원격 화면 캡쳐 및 녹화 기능을 허용/차단합니다.',
  'display_power_save_desc': '원격 중에 에이전트 PC의 화면 절전을 방지/유지합니다.',
  'system_power_save_desc': '원격 중에 에이전트 PC의 시스템 절전을 방지/유지합니다.',
  'security_agreement_desc': '보안서약서에 동의한 사용자만 접속이 가능하도록 설정합니다.',
  'function_settings_header': '* 정책관리 : 관리자는 중간관리자 및 사용자의 원격기능 및 접속환경과 같은 일괄 적용되는 정책을 설정할 수 있습니다.',
  'vaccine_desc': '설정한 프로세스/서비스명이 실행 중인 사용자 환경에서만 접속을 허용합니다.',
  'invalid_idle_time': '원격접속 유휴시간(분)을 확인해주세요.',
  'invalid_session_time': '원격접속 유지시간(분)을 확인해주세요.',
  'invalid_block_num': '인증실패 허용횟수(회)를 확인해주세요.',
  'invalid_min_os_major': '메이저OS 버전을 확인해주세요.',
  'invalid_min_os_minor': '마이너OS 버전을 확인해주세요.',
  'password_modified_error': '기존 비밀번호를 확인해주세요.',
  'password_change_limit': '비밀번호 사용기간이 만료되었습니다.<br>비밀번호를 변경해주세요.',
  'password_expired_desc': '설정한 기간 만료시 비밀번호를 변경해야 로그인 할 수 있습니다.',
  'self_unlock_desc': '사용자가 본인 인증을 통해 직접 계정 잠금을 해제할 수 있습니다.',
  'invalid_password_change_limit': '비밀번호 최대사용기간(일)을 확인해주세요.',
  'help_PWChangeLimit': `
    <h5>비밀번호 최대사용기간 도움말</h5><br>
    <h6 style="line-hight:1em;">
      비밀번호를 사용할 수 있는 최대 기간을 설정합니다.<br>
      최대 365일(1년)까지 설정할 수 있습니다.<br>
    </h6>
    <h6 style="padding:20px 0 0 0">
      (비밀번호 최대사용기간 미사용시 0입력)
    </h6>
  `,
  'excel_onloaded': '올바르게 작성된 하위사용자만 표시됩니다.<br>등록할 하위사용자를 선택하여 등록버튼을 눌러주세요.',
  'excel_user_submit': '실패 {failure}개를 제외한 나머지 계정정보가 일괄 등록되었습니다.',
  'excel_group_submit': '실패 {failure}개를 제외한 나머지 그룹정보가 일괄 등록되었습니다.',
  'excel_group_fail': '그룹정보 일괄등록을 실패하였습니다.<br>엑셀파일에 입력된 정보를 확인해주세요.',
  'groups': '그룹',
  'users': '사용자관리',
  'dashboard': '통계/이력',
  'payment_manage': '결제',
  'subscription': '서비스 신청/연장',
  'payment_history': '서비스 결제이력',
  'deleted_device_history': '에이전트 삭제 이력',
  'add_user': '하위사용자 추가',
  'add_group': '그룹 추가',
  'access_time': '접속시간',
  'no_devices': '에이전트',
  'add_ip': 'IP 추가',
  'delete_ip': 'IP 삭제',
  'add_ip_single': '단일 IP 추가',
  'add_ip_range': 'IP 범위 추가',
  'add_ip_subnet': '서브넷팅 추가',
  'add_ip_excel': 'Excel로 추가',
  'device_excel_fail': '에이전트 리스트 EXCEL 생성에 실패했습니다.',
  
  'mode_simple': 'SIMPLE',
  'mode_normal': 'NORMAL',
  'mode_change': '모드전환',
  'mode_change_simple': '심플모드',
  'mode_change_normal': '노멀모드',
  'icon_access': '접속가능',
  'icon_online': '온라인',
  'icon_offline': '오프라인',
  
  'agent_policy': '에이전트 정책',
  'agent_restart_time': '에이전트 정기 재시작 시간대 (매일)',
  'agent_restart_desc': '에이전트의 접속 유지 안정성 개선을 위한 정기 재시작 시간대를 설정합니다. 설정된 시간대에 순차적으로 에이전트가 자동 재시작 및 서버 자동 재접속됩니다. 업무에 지장이 없도록 사용량이 적은 시간대로 설정 권장합니다. 등록된 에이전트 중 원격 접속이 가능한 Online 상태의 Windows 및 Android 에이전트만 적용됩니다.',
  'agent_group_update': '에이전트 일괄 업데이트',
  'agent_group_desc': '등록된 에이전트 중 원격 접속이 가능한 Online 상태의 Windows 에이전트가 최신 버전의 에이전트로 업데이트됩니다. 업데이트는 순차적으로 적용되어 업데이트 완료 후 서버 자동 재접속됩니다.',
  'agent_update': '업데이트',
  'batch_update_desc': '최신 버전의 에이전트로 일괄 업데이트 합니다.',
  
  'statistics_policy': '통계 이력 주기 설정',
  'statistics_period': '주기',
  'day': '일',
  'month': '월',
  'year': '년',
  
  'excel_button': '엑셀',
  'no-agent-selected': '선택된 에이전트가 없습니다.',
  
  'add-group': '그룹 추가',
  'add-group-child': '그룹 추가 _하위그룹',
  'invalid_value': '유효하지 않은 값입니다',
  'app_info_delete': '애플리케이션 정보를 삭제했습니다.',
  'app_info_updated': '애플리케이션 정보가 수정되었습니다',
  'application_upload_success': '해당 애플리케이션 업로드 했습니다.',
  'application_upload_error': '해당 애플리케이션 업로드를 실패했습니다.',
  'application_add_success': '해당 애플리케이션을 추가했습니다.',
  'all_application': '모든 애플리케이션',
  'application_config': '애플리케이션 구성',
  'application': '애플리케이션',
  'all-application': '모든 애플리케이션',
  'applications': {
    'title': '애플리케이션',
    'version': '버전 화면 표시',
    'setting': '애플리케이션 구성 수정',
    'edit': '애플리케이션 정보 수정',
    'delete': '애플리케이션 삭제'
  },
  'delete_checked_application_confirm': '선택한 애플리케이션을 정말 삭제하시겠습니까?',
  'delete_checked_app_config_confirm': '선택한 구성을 정말 삭제하시겠습니까?',
  'config': '구성',
  'basic-config': '기본 구성',
  'department-members': '부서원',
  'admin': '마스터',
  'middle-managers': '부서장',
  'all-app-config': '모든 구성',
  'config-name': '구성 이름',
  'config-desc': '구성 설명',
  'config-edit': '수정',
  'config-delete': '삭제',
  'config-copy': '복사',
  'location-tracking': '에이전트 위치 추적',
  'enter-pin': 'PIN 입력',
  'scheduling-updates': '앱 업데이트 예약',
  'app_config_info_delete': '구성 정보를 삭제했습니다.',
  'app_config_info_updated': '구성 정보가 수정되었습니다',
  'updated_config_applied': '최신 구성 정보가 적용되었습니다.',
  'app_config_add_success': '구성 정보를 추가했습니다.',
  'pin_flag': '상담원이 접속시 PIN 번호 입력받기',
  'update-time': '업데이트 시간',
  'update-time-desc': '업데이트 예약이 체크되어 있지 않으면 즉시 업데이트 됩니다.',
  'installed': '설치함',
  'not-installed': '설치안함',
  'application-add-desc': '수정을 통해 애플리케이션을 추가해주시기 바랍니다.',
  'application-installation': '해당 애플리케이션을 설치합니다.',
  'application-not-installation': '해당 애플리케이션을 설치하지 않습니다.',
  'select_file': '파일을 선택해주세요.',
  'drop_file': '파일을 놓아주세요.',
  'file_upload_error': '파일을 놓아주세요.',
  'application_exist': '이미 존재하는 애플리케이션입니다.',
  'select_delete_group': '삭제할 그룹을 선택해주세요.',
  'select_delete_user': '삭제할 사용자를 선택해주세요.',
  'data_get_fail': '데이터를 가져오는데 실패하였습니다.',
  'application_add_error': '애플리케이션 추가 에러',
  'app_config_name': '구성 이름',
  'default-item-non-deletable': '기본 항목은 삭제할 수 없습니다.',
  'app_name_placeholder': '앱 이름이 존재하지 않습니다. 직접 입력해주세요.',
  'run_after_installation': '설치 후 실행',
  'add_application': '애플리케이션 추가',
  'add_config': '구성 추가',
  'update_schedule_error': '업데이트 예약 시간 설정이 올바르지 않습니다.',
  'edit_application': '애플리케이션 수정',
  'list_of_users': '그룹 접근 권한 사용자 목록',
  'list_of_devices': '그룹에 속한 에이전트 목록',
  'list_of_total_devices': '전체 에이전트 목록',
  'confirm': '확인',
  'password_reset_email': '비밀번호 재설정 메일 발송',
  'required': '필수항목',
  'selections': '선택항목',
  'info_update_interval': '기기정보 업데이트 주기',
  'sub_manager_limit': '허용된 하위 사용자 수를 초과하였습니다.',
}